import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import * as _ from "lodash";
import { BaseError } from "../../../../../../base-error";

@Component({
    selector: "transform-search",
    templateUrl: "./transform-search.component.html",
})

export class TransformSearchComponent extends BaseError {
    @Input() public search: object = {};
    @Output() public onCancel = new EventEmitter();
    @Output() public saveTransformation = new EventEmitter();
    @Input() public switchs: any = {};

    public searchTransformation: string = "none";

    public ngOnInit() {
        if (this.switchs.item.field.targetFieldProperties) {
            const existingTransformation = _.keys(_.pickBy(_.omit(this.switchs.item.field.targetFieldProperties, ["sortByFields", "inputTransformations"])));
            if (existingTransformation[0]) {
                this.searchTransformation = existingTransformation[0];
            }
        } else {
            this.search[this.searchTransformation] = true;
        }
    }

    public searchUpdate() {

        if (this.searchTransformation && this.searchTransformation !== "none") {
            for (const s in this.search) {
                if (this.search.hasOwnProperty(s) && s !== "sortByFields") {
                    this.search[s] = false;
                }
            }
            this.search[this.searchTransformation] = true;
        }
    }

    /*
    public save() {
        this.saveTransformation.emit({ data: this.search, switchs: this.switchs });
    }*/

}
